module.exports = __webpack_public_path__ + "static/media/55.2cebc336.png";